import React from 'react';
import { push } from 'react-router-redux';
import gettext from '@eb/gettext';

import { AlertChunky } from '@eb/eds-iconography';

import { timeoutSIWATimer as timeoutSIWATimerAction } from '../actions/auth';
import { trackTokenExpired } from '../actions/gaTracking';
import { BASE_URL } from '../constants';

export const SIWA_TIMEOUT_IN_MINUTES = 5;
export const SIWA_TIMEOUT_THRESHOLD = 30;

export const startSIWATimer = ({ dispatch, getState }) => {
    let interval;
    let expirationTimestampDate;

    const tick = () => {
        if (!expirationTimestampDate) {
            const {
                authentication: {
                    socialAuthenticationData: {
                        apple: { expirationTimestamp } = {},
                    },
                },
            } = getState();

            if (expirationTimestamp) {
                /*
                 * The expiration timestamp is the moment when the SIWA token becomes
                 * invalid. We still substract 30 seconds from it to allow the furter
                 * process of our own login.
                 */
                expirationTimestampDate = new Date(expirationTimestamp);
                expirationTimestampDate.setSeconds(
                    expirationTimestampDate.getSeconds() -
                        SIWA_TIMEOUT_THRESHOLD,
                );
            }
        } else {
            if (new Date() >= expirationTimestampDate) {
                stopTimer();
            }
        }
    };

    const startTimer = (intervalLength) => {
        interval = setInterval(tick, intervalLength);
    };

    const stopTimer = () => {
        clearInterval(interval);

        dispatch(
            timeoutSIWATimerAction({
                message: gettext('Your session expired. Please try again'),
                iconType: <AlertChunky />,
            }),
        );

        trackTokenExpired(getState());

        dispatch(push(BASE_URL));
    };

    startTimer(1000);
};
